import styled from '@emotion/styled';

import { Link } from 'gatsby';

const customButtonStyles = ({ customButtonBackgroundColor, customButtonTextColor, useBoldButtonText }) => `
  background-color: ${customButtonBackgroundColor ? customButtonBackgroundColor : '#266ff2'};
  color: ${customButtonTextColor ? customButtonTextColor : '#fff'};
  font-weight: ${useBoldButtonText ? 700 : 500};
`;

export const StyledInternalCtaLink = styled(Link)`
  ${customButtonStyles};
`;

export const StyledExternalCtaLink = styled.a`
  ${customButtonStyles};
`;
